import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { NgxsModule } from "@ngxs/store";
import { ValidatorsModule } from "@vattenfall/core";
import { UiModule } from "@vattenfall/ui";

import { FlowsFIRenewalLogin } from "./flows-fi-renewal-login.element";
import { FlowsFIRenewalLoginState } from "./flows-fi-renewal-login.element.state";

@NgModule({
  declarations: [FlowsFIRenewalLogin],
  imports: [
    CommonModule,
    FormsModule,
    UiModule,
    ReactiveFormsModule,
    ValidatorsModule,
    NgxsModule.forFeature([FlowsFIRenewalLoginState]),
  ],
  bootstrap: [FlowsFIRenewalLogin],
  exports: [FlowsFIRenewalLogin],
})
export class FlowsFIRenewalLoginModule {}
